import durationMixin from '@/store/modules/timeLog/mixins/duration';

export default {
  mixins: [durationMixin],
  computed: {
    totalTime() {
      return this.timeLogsDuration(this.timeLogs, this.startTime, this.endTime, this.viewMode, this.notDeletedFilter);
    },
    totalDeletedTime() {
      return this.timeLogsDuration(this.timeLogs, this.startTime, this.endTime, this.viewMode, this.deletedFilter);
    },
    totalLateTime() {
      return this.timeLogsDuration(this.timeLogs, this.startTime, this.endTime, this.viewMode, this.lateFilter, null, this.lateEndValue);
    },
    totalOverTime() {
      return this.timeLogsDuration(this.timeLogs, this.startTime, this.endTime, this.viewMode, this.overFilter, null, this.overEndValue);
    },
    count() {
      return this.timeLogs ? this.timeLogs.length : 0;
    },
  },
  methods: {
    deletedFilter(record) {
      return record.deleted;
    },
    notDeletedFilter(record) {
      return !record.deleted;
    },
    lateFilter(record) {
      return record.actual_started_at !== null && record.actual_started_at !== 'undefined';
    },
    overFilter(record) {
      return record.actual_stopped_at !== null && record.actual_stopped_at !== 'undefined';
    },
    lateEndValue(record) {
      return record.actual_started_at;
    },
    overEndValue(record) {
      return record.actual_stopped_at;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/timeLog/mixins/totalsCounter.js